import React, { useEffect } from "react";
import "./styled.css";
//redux
import { connect } from "react-redux";
//tags
import MetaTags from "react-meta-tags";

function Repository(props) {
  function visitLink(e) {
    window.open(e, "_blank");
  }

  useEffect(() => {
    // document.activeElement.tabIndex = 13
    document.getElementById("title-repository").focus();
    props.loadingUserOff();
  }, []);
  return (
    <section className="section-repository" id="section-mainStage">
      <MetaTags>
        <title>Digital Lovers Festival - Página Repositório de Materiais</title>
      </MetaTags>
      <a id="title-repository" className="title-home" tabIndex={12}>
        Página Repositório de Materiais
      </a>
      <div className="div-cards-repository">
        <div className="card-repository">
          <a className="card-title-repository" tabIndex={13}>
            Area de Negócios
          </a>
          {/* <button
            tabIndex={14}
            title="Acesse a página DT FY22 - Fera Mevaverso BRA"
            className="button-item-repository"
            onClick={() =>
              visitLink(
                "https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/AREA%20DE%20NEGOCIOS/DT%20FY22%20-%20Fera%20Mevaverso%20BRA.pdf"
              )
            }
          >
            DT FY22 - Fera Mevaverso BRA
          </button> */}

          <a
            tabIndex={14}
            title="Acesse o arquivo DT FY22 - Fera Mevaverso BRA"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/AREA%20DE%20NEGOCIOS/DT%20FY22%20-%20Fera%20Mevaverso%20BRA.pdf"
            target={"_blank"}
          >
            DT FY22 - Fera Mevaverso BRA
          </a>

          <a
            tabIndex={15}
            title="Acesse o arquivo Deck ITSS - Exec Brasil"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/AREA%20DE%20NEGOCIOS/Deck%20ITSS%20-%20Exec%20Brasil%20.pdf"
            target={"_blank"}
          >
            Deck ITSS - Exec Brasil
          </a>

          <a
            tabIndex={16}
            title="Acesse o arquivo Digital Strategy - Propósito & Capacidades"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/AREA%20DE%20NEGOCIOS/Digital%20Strategy%20-%20%20Prop%C3%B3sito%20%26%20Capacidades.pdf"
            target={"_blank"}
          >
            Digital Strategy - Propósito & Capacidades
          </a>

          <a
            tabIndex={17}
            title="Acesse o arquivo Áreas de Negócios - BPO"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/AREA%20DE%20NEGOCIOS/%C3%81reas%20de%20Neg%C3%B3cios%20-%20BPO.pdf"
            target={"_blank"}
          >
            Áreas de Negócios - BPO
          </a>
        </div>
      </div>

      <div className="div-cards-repository">
        <div className="card-repository">
          <a className="card-title-repository" tabIndex={18}>
            BSA
          </a>

          <a
            tabIndex={19}
            title="Acesse o arquivo Boas vindas Delivery FY22"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/BSA/Boas%20vindas%20Delivery%20FY22.pdf"
            target={"_blank"}
          >
            Boas vindas Delivery FY22
          </a>

          <a
            tabIndex={20}
            title="Acesse o arquivo Brasil Legal - Atribuições e Quem somos"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/BSA/Brasil%20Legal%20-%20Atribui%C3%A7%C3%B5es%20e%20Quem%20somos.pdf"
            target={"_blank"}
          >
            Brasil Legal - Atribuições e Quem somos
          </a>

          <a
            tabIndex={21}
            title="Acesse o arquivo DIGITAL LOVERS FESTIVAL_PEOPLE"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/BSA/DIGITAL%20LOVERS%20FESTIVAL_PEOPLE.pdf"
            target={"_blank"}
          >
            Digital Lovers Festival People
          </a>

          <a
            tabIndex={22}
            title="Acesse o arquivo Digital Lovers - CDG"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/BSA/Digital%20Lovers%20-%20CDG.pdf"
            target={"_blank"}
          >
            Digital Lovers - CDG
          </a>

          <a
            tabIndex={23}
            title="Acesse o arquivo Digital Lovers - Compras e Facilities"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/BSA/Digital%20Lovers%20-%20Compras%20e%20Facilities.pdf"
            target={"_blank"}
          >
            Digital Lovers - Compras e Facilities
          </a>

          <a
            tabIndex={24}
            title="Acesse o arquivo Digital Lovers - Contabilidade"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/BSA/Digital%20Lovers%20-%20Contabilidade.pdf"
            target={"_blank"}
          >
            Digital Lovers - Contabilidade
          </a>

          <a
            tabIndex={25}
            title="Acesse o arquivo Digital Lovers - Tesouraria"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/BSA/Digital%20Lovers%20-%20Tesouraria.pdf"
            target={"_blank"}
          >
            Digital Lovers - Tesouraria
          </a>

          <a
            tabIndex={26}
            title="Acesse o arquivo Marketing & Comunicação Brasil_Digital Lovers Festival"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/BSA/Marketing%20%26%20Comunica%C3%A7%C3%A3o%20Brasil_Digital%20Lovers%20Festival%20%281%29.pdf"
            target={"_blank"}
          >
            Marketing & Comunicação Brasil_Digital Lovers Festival
          </a>

          <a
            tabIndex={27}
            title="Acesse o arquivo NTT DATA EMEAL Corporate video_PTBR"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/BSA/NTT%20DATA%20EMEAL%20Corporate%20video_PTBR%20%281%29.mp4"
            target={"_blank"}
          >
            NTT DATA EMEAL Corporate video_PTBR
          </a>

          <a
            tabIndex={28}
            title="Acesse o arquivo SecurityCorporateBrasil_NTTDATA 10.2022"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/BSA/SecurityCorporateBrasil_NTTDATA%2010.2022.pdf"
            target={"_blank"}
          >
            SecurityCorporateBrasil_NTTDATA 10.2022
          </a>

          <a
            tabIndex={29}
            title="Acesse o arquivo Strategic Alliances - Portugues"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/BSA/Strategic%20Alliances%20-%20Portugues.pdf"
            target={"_blank"}
          >
            Strategic Alliances - Portugues
          </a>
        </div>
      </div>

      <div className="div-cards-repository">
        <div className="card-repository">
          <a className="card-title-repository" tabIndex={30}>
            Setores
          </a>

          <a
            tabIndex={31}
            title="Acesse o arquivo Healthcare"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/SETORES/HEALTHCARE.html"
            target={"_blank"}
          >
            Healthcare
          </a>

          <a
            tabIndex={32}
            title="Acesse o arquivo NTT DATA - Sua Parceria de 5G"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/SETORES/NTT%20DATA%20-%20SUA%20PARCEIRA%20DE%205G.mp4"
            target={"_blank"}
          >
            NTT DATA - Sua Parceria de 5G
          </a>

          <a
            tabIndex={33}
            title="Acesse o arquivo NTT Data - Envisioning Banking as a Lifestyle"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/SETORES/NTT%20Data%20-%20Envisioning%20Banking%20as%20a%20Lifestyle.mp4"
            target={"_blank"}
          >
            NTT Data - Envisioning Banking as a Lifestyle
          </a>

          <a
            tabIndex={34}
            title="Acesse o arquivo Seguros"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/SETORES/Seguros.pdf"
            target={"_blank"}
          >
            Seguros
          </a>

          <a
            tabIndex={35}
            title="Acesse o arquivo Utilities Plan - Brazil deck"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/SETORES/Utilities%20Plan%20-%20Brazil%20deck.pdf"
            target={"_blank"}
          >
            Utilities Plan - Brazil deck
          </a>

          <a
            tabIndex={35}
            title="Acesse o arquivo Varejo e Bens de Consumo"
            className="button-item-repository"
            href="https://s3.us-east-1.amazonaws.com/bucket.aws.public/hall_83778/REPOSITORIO%20DE%20MATERIAIS/SETORES/VAREJO%20E%20BENS%20DE%20CONSUMO.html"
            target={"_blank"}
          >
            Varejo e bens de consumo
          </a>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

const mapDispatchToProps = function (dispatch) {
  return {
    loadingUserOff: (data) => {
      return dispatch({ type: "LOGIN_NAVIGATION_OFF", data });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Repository);
